import reducer from 'state/direct-order-recurring/insurance/reducer';
import actions from 'state/direct-order-recurring/insurance/actionCreators';
import selectors from 'state/direct-order-recurring/insurance/selectors';
import effects from 'state/direct-order-recurring/insurance/effects';

export { actions, selectors, effects };
export default reducer;
